export const webhookYaml = () => `webhooks:
  - id: "||VARIABLE_KEY_id||"
    name: "||VARIABLE_KEY_name||"
    description:
    connectionId: "||VARIABLE_KEY_connectionId||"
    targets: {}`;

export const webhookEventYaml = () => `id: "||VARIABLE_KEY_id||"
objectIds: []
matchFilter: $.the.jsonpath.query.to.the.action
matchPattern: "The action name or regular expression that matched the desired event"
dataFilter: $.RawMessage
dataParser:
  jsonata: {}
pullSteps: []
options: []
`;
